import React,{useContext} from "react";
import { Tag, Tooltip } from "antd";
import { EditOutlined, WarningOutlined } from "@ant-design/icons";
import { EstadoFirmaColaborador } from "enums/EstadoFirmaColaborador";
import { CategoriaDocumento } from "enums/CategoriaDocumento";
import { EstadoAprobacion } from "enums/reclutamiento-y-seleccion/EstadoAprobacion"; 
import { SecurityContext } from "context/SecurityContextProvider";


const EtiquetaEstadoFirmaColaborador = ({ documento }) => {
    const { getUsuarioAutenticado } = useContext(SecurityContext);
    const isExplomin =
          getUsuarioAutenticado().empresaSeleccionada?.ruc === "20501523837"
            ? true
            : false;

  switch (documento.estadoFirmaColaborador) {
    case EstadoFirmaColaborador.NO_APLICA:
      return (
        <Tag style={{ color: "#7f7f7f", marginRight: "0px" }}>No Aplica</Tag>
      );

    case EstadoFirmaColaborador.PENDIENTE:
      return (
        <Tag color="gold" className="milegajo-ant-tag">
          PENDIENTE
        </Tag>
      );

    case EstadoFirmaColaborador.FIRMADO:
      return (
        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          {isExplomin &&
          CategoriaDocumento.FORMULARIOS.id ===
            documento.categoriaDocumentoId &&
          documento.estadoAprobacion === EstadoAprobacion.RECHAZADO ? (
            <Tag color="gold" className="milegajo-ant-tag">
              PENDIENTE
            </Tag>
          ) : (
            <Tag color="green" className="milegajo-ant-tag pointer">
              <EditOutlined /> FIRMADO
            </Tag>
          )}
          {isExplomin &&
            (CategoriaDocumento.FORMULARIOS.id === documento.categoriaDocumentoId 
              || CategoriaDocumento.CARGA_DOCUMENTO.id === documento.categoriaDocumentoId) &&
            documento.estadoAprobacion === EstadoAprobacion.PENDIENTE && (
              <Tooltip
                title={<Tag color="blue">Pendiente de Aprobación</Tag>}
                overlayInnerStyle={{ backgroundColor: "white" }}
              >
                <WarningOutlined
                  style={{
                    color: "#faad14",
                    fontSize: "16px",
                    cursor: "pointer",
                  }}
                />
              </Tooltip>
            )}
        </div>
      );

    default:
      return (
        <Tag color="gold" className="milegajo-ant-tag">
          PENDIENTE
        </Tag>
      );
  }
};

export default EtiquetaEstadoFirmaColaborador;
